import React, { createContext } from 'react';
import PropTypes from 'prop-types';
import useQuickLinks from '../hooks/useQuickLinks';
import { dataModel } from '../util/data-model';

export const QuickLinksContext = createContext();

const QuickLinksProvider = ({ children, componentId, linkList }) => {
  const { links, setLinks } = useQuickLinks(componentId, linkList);

  return (
    <QuickLinksContext.Provider value={{ links, setLinks, componentId }}>
      {children}
    </QuickLinksContext.Provider>
  );
};

QuickLinksProvider.dataModel = dataModel;
QuickLinksProvider.displayName = 'QuickLinksProvider';

QuickLinksProvider.defaultProps = {
  linkList: undefined,
}

QuickLinksProvider.propTypes = {
  children: PropTypes.node.isRequired,
  componentId: PropTypes.string.isRequired,
  linkList: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    href: PropTypes.string,
    label: PropTypes.string,
  })),
};

export default QuickLinksProvider;